import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const TenantAdminAuditLog = React.lazy(() =>
    import('../TenantAdminAuditLog')
);
const tenantAdminAuditLogRoutesRegistry = [
    {
        path: PAGE_URL.TENANT_ADMIN_AUDIT_LOG_PAGE,
        element: <TenantAdminAuditLog />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default tenantAdminAuditLogRoutesRegistry;
